/* custom code start */
if (!customElements.get("home-content-slider")) {
  class HomeContentSlider extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(".hct-tab"));
      this.media = Array.from(this.querySelectorAll(".hct-media__item"));
      this.panels = Array.from(this.querySelectorAll(".hct-panel"));
      this.tabsContainer = this.querySelector(".hct-tabs");

      if (this.tabs.length === 0) return;

      this.onTabClick = this.onTabClick.bind(this);
      this.onTabKeydown = this.onTabKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener("shopify:block:select", this.onBlockSelect);
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", this.onTabClick);
        tab.addEventListener("keydown", this.onTabKeydown);
      });

      const active = this.tabs.find((t) => t.classList.contains("is-active")) || this.tabs[0];
      this.activate(active.dataset.tab);
    }

    disconnectedCallback() {
      this.removeEventListener("shopify:block:select", this.onBlockSelect);
      this.tabs.forEach((tab) => {
        tab.removeEventListener("click", this.onTabClick);
        tab.removeEventListener("keydown", this.onTabKeydown);
      });
    }

    onTabClick(event) {
      const tab = event.currentTarget;
      this.activate(tab.dataset.tab);
      this.scrollTabIntoView(tab);
    }

    onTabKeydown(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      let next = null;

      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          next = this.tabs[(index + 1) % this.tabs.length];
          break;
        case "ArrowLeft":
        case "ArrowUp":
          next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
          break;
        case "Home":
          next = this.tabs[0];
          break;
        case "End":
          next = this.tabs[this.tabs.length - 1];
          break;
        default:
          return;
      }

      event.preventDefault();
      next.focus({ preventScroll: true });
      this.activate(next.dataset.tab);
      this.scrollTabIntoView(next);
    }

    onBlockSelect(event) {
      const tab = event.target.closest(".hct-tab");
      if (tab) {
        this.activate(tab.dataset.tab);
        this.scrollTabIntoView(tab);
      }
    }

    // Keep the selected tile fully visible — centre it in the scrollable tab row
    // (mobile) so the customer never has to scroll to reach a peeking tile.
    scrollTabIntoView(tab) {
      const container = this.tabsContainer;
      if (!container || !tab) return;
      if (container.scrollWidth <= container.clientWidth) return; // not scrollable (wraps on desktop)

      const containerRect = container.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      const delta = tabRect.left + tabRect.width / 2 - (containerRect.left + containerRect.width / 2);
      container.scrollBy({ left: delta, behavior: "smooth" });
    }

    activate(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === id;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      this.media.forEach((item) => {
        item.classList.toggle("is-active", item.dataset.tab === id);
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tab === id;
        panel.classList.toggle("is-active", isActive);
        panel.toggleAttribute("hidden", !isActive);
      });
    }
  }

  customElements.define("home-content-slider", HomeContentSlider);
}
/* custom code end */
